import { useAuth } from '@skyslope/auth-react';

const useGetUserLoginId = (): string | undefined => {
  const { userContext } = useAuth();
  return userContext?.loginId;
};

export default useGetUserLoginId;
